import "./loader.scss";
import React from "react";

type LoaderSize = 'XS' | 'S' | 'M' | 'L' | 'XL';

type LoaderStyleProps = {
    size?: LoaderSize;
    inline?: boolean;
}

type Props = LoaderStyleProps & {
    children?: React.ReactNode;
}

export const Loader = (props: Props) => {
    let { children } = props;
    return (
        <div className={`loader`} style={getContentStyle(props)}>
            <div className="loader-icon"></div>
            <div className="loader-text">{children}</div>
        </div>
    );
}

const getLoaderScale = (size: LoaderSize): number => {
    switch (size) {
        case "XS": return 0.2;
        case "S": return 0.4;
        case "M": return 0.6;
        case "L": return 1;
        case "XL": return 2;
    }
}

const defaultStyle = {
    "--dimension": 64,
    "--inner-bumper": 8,
    "--outer-bumper": 16,
    "--ring-width": 4
};

const getContentStyle = (props: LoaderStyleProps): React.CSSProperties => {
    const { size = "L", inline = false } = props;
    const scale = getLoaderScale(size);
    return {
        "--display": inline ? "inline-block" : "flex",
        "--dimension": `${defaultStyle["--dimension"] * scale}px`,
        "--inner-bumper": `${defaultStyle["--inner-bumper"] * scale}px`,
        "--outer-bumper": `${defaultStyle["--outer-bumper"] * scale}px`,
        "--ring-width": `${defaultStyle["--ring-width"] * scale}px`,
    } as React.CSSProperties;
}

// const getLoaderSize = (size: LoaderSize): number => {
//     switch (size) {
//         case 'XS': return 12;
//         case 'S': return 16;
//         case 'M': return 24;
//         case 'L': return 64;
//         case 'XL': return 96;
//         default:
//             throw "Nonexistent size.";
//     }
// }

// const getBumperSize = (size: LoaderSize) => {
//     switch (size) {
//         case "XS": return 2;
//         case "S": return 4;
//         case "M": return 6;
//         case "L": return 8;
//         case "XL": return 10;
//     }
// }

// const getRingWidth = (size: LoaderSize) => {
//     switch (size) {
//         case "XS": return 2;
//         case "S": return 2;
//         case "M": return 2;
//         case "L": return 3;
//         case "XL": return 4;
//     }
// }